var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramECommerce128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eCommerce-Pictogram_128x128px_Current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "monitor",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 9,
    y: 18,
    width: 100.208333,
    height: 77.0833333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Focus",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFCC00",
    x: 9,
    y: 79.6666667,
    width: 100.208333,
    height: 15.4166667
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.9375,
    y1: 87.375,
    x2: 101.5,
    y2: 87.375,
    id: "power-on",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.8333333,
    y1: 108.572917,
    x2: 76.4479167,
    y2: 108.572917,
    id: "stand-horizontal",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.1041667,
    y1: 95.0833333,
    x2: 59.1041667,
    y2: 106.645833,
    id: "stand-vertical",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "card",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 72.59375,
    y: 35.34375,
    width: 47.40625,
    height: 30.0625,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.460937,35.34375 L118.2,35.34375 C119.194113,35.34375 120,36.1496375 120,37.14375 L120,63.60625 C120,64.6003625 119.194113,65.40625 118.2,65.40625 L110.460937,65.40625 L110.460937,65.40625 L95.71875,50.375 L110.460937,35.34375 Z",
    id: "focus",
    stroke: "#4F4C4D",
    strokeWidth: 2,
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "brand",
    stroke: "#4F4C4D",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    points: "81.84375 41.125 85.3125 44.59375 81.84375 48.0625 78.375 44.6246823"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramECommerce128);
export default __webpack_public_path__ + "static/media/pictogramECommerce128.6a9e232063d186d0c74f02cf1cbf87e2.svg";
export { ForwardRef as ReactComponent };